// extracted by mini-css-extract-plugin
export default {"container":"v1Vi07","floatingText":"M_bsB2"};